export const AgricultureAdvatages = () => {
  return (
    <>


      <div class="row charchole py-4 mb-5 px-lg-4" id="government_content">
        <div class="col-12 col-md-10 mx-auto py-4">
          <h3 class="fw-bold white text-center">ADVANTAGES</h3>

          <div class="zoom-in-out-box2 m-auto">
            <hr />
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-4 white py-2 ">
          <div class=" border border1 text-center px-2">
            {/* <img src="Assets/Images/Agriculture/Holistic Approach.png" alt="image not found" style={{ width: '120px' }} class="mt-2 ds" /> */}
            <img src="https://ik.imagekit.io/gplanet/Cdat%20Website%202025/Holistic%20Approach.png" alt="image not found" style={{ width: '120px' }} class="mt-2 ds" />
            <h5 class="pt-4 fw-bold pb-3"> Holistic Approach</h5>

            <input type="checkbox" hidden class="read-more-state" id="read-more3" />
            <div className="read-more-wrap">

              <p className="p1  text-white"> With our ITC model, we take a holistic approach to agriculture, incorporating data-driven insights,
                <span className="read-more-target ps-2">

                  technology integration, and effective communication for comprehensive farm management.
                </span>
              </p>
            </div>
            <label for="read-more3" className="read-more-trigger_closed pb-4  pointer">Read More...</label>
            <label for="read-more3" className="read-more-trigger_opened pb-4 pointer">Read Less</label>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-4 white py-2">
          <div class=" border border2 text-center px-2">
            {/* <img src="Assets/Images/Agriculture/Data-Driven Decisions.png" alt="image not found" style={{ width: '120px' }} class="mt-2 ds" /> */}
            <img src="https://ik.imagekit.io/gplanet/Cdat%20Website%202025/Data-Driven%20Decisions.png" alt="image not found" style={{ width: '120px' }} class="mt-2 ds" />
            <h5 class="pt-4 fw-bold pb-3">Data-Driven Decisions</h5>
            <input type="checkbox" hidden class="read-more-state" id="read-more4" />
            <div className="read-more-wrap">

              <p className="p1  text-white">Harnessing the power of data analytics, we provide farmers with valuable insights to make
                <span className="read-more-target ps-2">
                  informed decisions, optimize resource allocation, and maximize yields.
                </span>
              </p>
            </div>
            <label for="read-more4" className="read-more-trigger_closed pb-4  pointer">Read More...</label>
            <label for="read-more4" className="read-more-trigger_opened pb-4 pointer">Read Less</label>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-4 white py-2 ">
          <div class=" border border3 text-center px-2">
            {/* <img src="Assets/Images/Agriculture/Precision Agriculture.png" alt="image not found" style={{ width: '120px' }} class="mt-2 ds" /> */}
            <img src="https://ik.imagekit.io/gplanet/Cdat%20Website%202025/Precision%20Agriculture.png" alt="image not found" style={{ width: '120px' }} class="mt-2 ds" />
            <h5 class="pt-4 fw-bold pb-3">Precision Agriculture</h5>
            <input type="checkbox" hidden class="read-more-state" id="read-more4" />

            <div className="read-more-wrap">
              <p className="p1  text-white">Through the ITC model, we introduce precision agriculture practices, using advanced
                <span className="read-more-target ps-2">
                  technologies like GPS, drones, and sensors for precise crop management, leading to enhanced productivity.
                </span>
              </p>
            </div>
            <label for="read-more4" className="read-more-trigger_closed pb-4  pointer">Read More...</label>
            <label for="read-more4" className="read-more-trigger_opened pb-4 pointer">Read Less</label>

          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-4 white py-2 mx-auto">
          <div class=" border border4 text-center px-2">
            {/* <img src="Assets/Images/Agriculture/Sustainable Farming.png" alt="image not found" style={{ width: '120px' }} class="mt-2 ds" /> */}
            <img src="https://ik.imagekit.io/gplanet/Cdat%20Website%202025/Sustainable%20Farming.png" alt="image not found" style={{ width: '120px' }} class="mt-2 ds" />
            <h5 class="pt-4 fw-bold pb-3">Sustainable Farming</h5>
            <input type="checkbox" hidden class="read-more-state" id="read-more4" />

            <div className="read-more-wrap">
              <p className="p1  text-white">Our ITC model promotes sustainable farming practices, promoting conservation, minimizing
                <span className="read-more-target ps-2">
                  waste, and preserving natural resources for a greener future.reliability throughout the employee lifecycle.
                </span>
              </p>
            </div>
            <label for="read-more4" className="read-more-trigger_closed pb-4  pointer">Read More...</label>
            <label for="read-more4" className="read-more-trigger_opened pb-4 pointer">Read Less</label>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-4 white py-2 mx-auto">
          <div class=" border border5 text-center px-2">
            {/* <img src="Assets/Images/Agriculture/monitoring.png" alt="image not found" style={{ width: '120px' }} class="mt-2 ds" /> */}
            <img src="https://ik.imagekit.io/gplanet/Cdat%20Website%202025/monitoring.png" alt="image not found" style={{ width: '120px' }} class="mt-2 ds" />
            <h5 class="pt-4 fw-bold pb-3">Real-Time Monitoring</h5>
            <input type="checkbox" hidden class="read-more-state" id="read-more4" />
            <div className="read-more-wrap">

              <p className="p1  text-white"> Stay updated with real-time monitoring of weather conditions, soil health, and crop growth,
                <span className="read-more-target ps-2">

                  allowing prompt actions to address challenges and improve outcomes.
                </span>
              </p>
            </div>
            <label for="read-more4" className="read-more-trigger_closed pb-4  pointer">Read More...</label>
            <label for="read-more4" className="read-more-trigger_opened pb-4 pointer">Read Less</label>
          </div>
        </div>
      </div>
    </>
  )
}